// WindowFunctionButton.tsx
import React from 'react';
// import { SiWindows11 } from 'react-icons/si';
import SiWindows11 from '@mui/icons-material/Window';
interface WindowFunctionButtonProps {
  onClick: () => void;
  isEnabled: boolean;
}

const WindowFunctionButton: React.FC<WindowFunctionButtonProps> = ({ onClick, isEnabled }) => {
  return (
    <button
      type="button"
      className="buttonCommon columnDown"
      title="Window Function"
      onClick={onClick}
      disabled={!isEnabled} // Disable button if not enabled
      style={{ padding: 0 }}
    >
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingRight: '5px',
          color: 'rgb(211, 211, 211)',
        }}
      >
        <SiWindows11 />
      </span>{' '}
    </button>
  );
};

export default WindowFunctionButton;
